module.exports = __webpack_public_path__ + "static/media/28-Lainez.20372445.png";